module.exports = __webpack_public_path__ + "img/LooperGroup_2x.98baf10a.png";